import React, {Component} from 'react';
import {connect} from 'react-redux';
import qs from 'qs';
import {
  updateSearchPageQueryParams,
  updateSearching,
  updateSearchPageSearchKeyWords,
  updateSearchPagePriceData,

  startSearching,
  stopSearching,

  updateSearchPageSitesLeft,
  decrementSearchPageSitesLeft
} from '../../reducers/searchPageReducer';
import {Input, Icon} from 'semantic-ui-react';
import spinner from '../../assets/loading_spinner.svg';
// import {Link} from 'react-router-dom';

import './SearchPage.css';

import ReactTable from "react-table";
import 'react-table/react-table.css';


import io from 'socket.io-client';

let socket;

// currently: Amazon, Newegg, B&H, Best Buy
const SITE_SOURCES_NUM = 4;

export class SearchPage extends Component {
  constructor(props) {
    super(props);
    const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    console.log(queryParams);
    console.log('queryParams[keywords]: ' + queryParams['keywords']);
    this.props.updateSearchPageQueryParams(queryParams['keywords']);
    this.props.updateSearchPageSearchKeyWords(queryParams['keywords']);

    this.handleSearchBoxInputChange = this.handleSearchBoxInputChange.bind(this);
    this.handleSearchKeyUp = this.handleSearchKeyUp.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);

    this.decrementAndCheckforSearchCompleteness = this.decrementAndCheckforSearchCompleteness.bind(this);
    this.handleAmazonData = this.handleAmazonData.bind(this);
    this.handleNeweggData = this.handleNeweggData.bind(this);
    this.handleBHData = this.handleBHData.bind(this);
    this.handleBestBuyData = this.handleBestBuyData.bind(this);
  }

  componentDidMount() {
    const original = this;
    socket = io(process.env.REACT_APP_CRAWLER_ENDPOINT, {
      path: '/blah',
      transports: ['websocket'],
      secure: true
    });

    socket.on('connect', function () {
      console.log('price api connected');
      original.props.startSearching({numSites: SITE_SOURCES_NUM, keywords: original.props.searchPageQueryParams});
      socket.emit('keywords', original.props.searchPageQueryParams);
    });
    socket.on('disconnect', function () {
      console.log('price api disconnected');
    })
    socket.on('chat message', function(msg){
      console.log('chat message received');
    });
    socket.on('amazon', function (msg) {
      console.log('amazon pricing received');
      // console.log(msg);
      const processed = original.handleAmazonData(msg.amazon);
      const concatenated = original.props.searchPagePriceData.concat(processed);
      original.props.updateSearchPagePriceData(concatenated);
      original.decrementAndCheckforSearchCompleteness();
    });
    socket.on('newegg', function (msg) {
      console.log('newegg pricing received');
      // console.log(msg);
      const processed = original.handleNeweggData(msg.newegg);
      const concatenated = original.props.searchPagePriceData.concat(processed);
      original.props.updateSearchPagePriceData(concatenated);
      original.decrementAndCheckforSearchCompleteness();
    });
    socket.on('bh', function (msg) {
      console.log('bh pricing received');
      // console.log(msg);
      const processed = original.handleBHData(msg.bh);
      const concatenated = original.props.searchPagePriceData.concat(processed);
      original.props.updateSearchPagePriceData(concatenated);
      original.decrementAndCheckforSearchCompleteness();
    });
    socket.on('bestbuy', function (msg) {
      console.log('bestbuy pricing received');
      // console.log(msg);
      const processed = original.handleBestBuyData(msg.bestbuy);
      const concatenated = original.props.searchPagePriceData.concat(processed);
      original.props.updateSearchPagePriceData(concatenated);
      original.decrementAndCheckforSearchCompleteness();
    });
  }

  decrementAndCheckforSearchCompleteness() {
    this.props.decrementSearchPageSitesLeft();
    if (this.props.searchPageSitesLeft <= 0) {
      this.props.stopSearching(this.props.searchPagePriceData);
      socket.disconnect();
    }
  }

  handleSearchBoxInputChange(event) {
    const val = event.target.value;
    this.props.updateSearchPageSearchKeyWords(val);
  }

  handleSearchKeyUp(event) {
    // user pressed enter in search box and textbox is not empty
    if (event.keyCode === 13 && this.props.searchPageKeyWords) {
      this.handleSearchSubmit();
    }
  }

  handleSearchSubmit() {
    console.log('search clicked');
    if (!this.props.searching && this.props.searchPageKeyWords) {
      const val = this.props.searchPageKeyWords;
      this.props.updateSearchPageQueryParams(val);
      this.props.startSearching({numSites: SITE_SOURCES_NUM, keywords: this.props.searchPageKeyWords});
      this.props.history.push(`/search?keywords=${val}`);

      const original = this;
      socket = io(process.env.REACT_APP_CRAWLER_ENDPOINT, {
        path: '/blah',
        transports: ['websocket'],
        secure: true
      });

      socket.on('connect', function () {
        console.log('price api connected');
        original.props.startSearching({numSites: SITE_SOURCES_NUM, keywords: original.props.searchPageQueryParams});
        socket.emit('keywords', original.props.searchPageQueryParams);
      });
      socket.on('disconnect', function () {
        console.log('price api disconnected');
      })
      socket.on('chat message', function(msg){
        console.log('chat message received');
      });
      socket.on('amazon', function (msg) {
        console.log('amazon received:');
        console.log(msg);
        const processed = original.handleAmazonData(msg.amazon);
        const concatenated = original.props.searchPagePriceData.concat(processed);
        original.props.updateSearchPagePriceData(concatenated);
        original.decrementAndCheckforSearchCompleteness();
      });
      socket.on('newegg', function (msg) {
        console.log('newegg received:');
        console.log(msg);
        const processed = original.handleNeweggData(msg.newegg);
        const concatenated = original.props.searchPagePriceData.concat(processed);
        original.props.updateSearchPagePriceData(concatenated);
        original.decrementAndCheckforSearchCompleteness();
      });
      socket.on('bh', function (msg) {
        console.log('bh pricing received');
        // console.log(msg);
        const processed = original.handleBHData(msg.bh);
        const concatenated = original.props.searchPagePriceData.concat(processed);
        original.props.updateSearchPagePriceData(concatenated);
        original.decrementAndCheckforSearchCompleteness();
      });
      socket.on('bestbuy', function (msg) {
        console.log('bestbuy pricing received');
        // console.log(msg);
        const processed = original.handleBestBuyData(msg.bestbuy);
        const concatenated = original.props.searchPagePriceData.concat(processed);
        original.props.updateSearchPagePriceData(concatenated);
        original.decrementAndCheckforSearchCompleteness();
      });
    }
  }

  handleAmazonData(data) {
    let processedData = [];
    for(const item of data) {
      processedData.push({
        store: 'Amazon',
        title: item.title,
        id: item.asin,
        link: item.link,
        image: item.img_amz,
        price: item.price
      });
    }
    return processedData;
  }

  handleNeweggData(data) {
    let processedData = [];
    for(const item of data) {
      processedData.push({
        store: 'Newegg',
        title: item.title,
        id: item.neweggId,
        link: item.link,
        image: item.img_newegg,
        price: item.price
      });
    }
    return processedData;
  }

  handleBHData(data) {
    let processedData = [];
    for(const item of data) {
      processedData.push({
        store: 'B&H',
        title: item.title,
        id: item.bhId,
        link: item.link,
        image: item.img_bh,
        price: item.price
      });
    }
    return processedData;
  }

  handleBestBuyData(data) {
    let processedData = [];
    for(const item of data) {
      processedData.push({
        store: 'Best Buy',
        title: item.title,
        id: item.bestBuySku,
        link: item.link,
        image: item.img_bestbuy,
        price: item.price
      });
    }
    return processedData;
  }

  render() {
    const storeData = this.props.searchPagePriceData;

    const storeTableColumns = [{
      Header: 'Pic',
      accessor: 'image',
      Cell: props => <img src={props.value} alt="search result" />
    }, {
      Header: 'Retailer',
      accessor: 'store'
    }, {
      Header: 'Title',
      accessor: 'title'
    }, {
      Header: 'Price',
      accessor: 'price',
      Cell: props => <span>${props.value}</span>
    }, {
      Header: 'Link',
      accessor: 'link',
      Cell: props => <a href={props.value} target="_blank">Go to Product</a>
    }];

    return (
      <div>
        <div>
          <div>
            <Input icon={<Icon name='search' inverted circular link onClick={this.handleSearchSubmit} />} placeholder='Start your search here!' value={this.props.searchPageKeyWords} onChange={this.handleSearchBoxInputChange} onKeyUp={this.handleSearchKeyUp} disabled={this.props.searching} name="searchField" type="text" maxLength="255" size="huge"/>
          </div>
        </div>
        <div>
          {this.props.searching &&
            <img className="logo" src={spinner} alt="searching spinner animation" id="spinner-img"/>
          }
        </div>
        <div>
          <ReactTable
            data={storeData}
            columns={storeTableColumns}
            pageSize={this.props.searchPagePriceData.length}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    searchPageQueryParams: state.searchPage.searchPageQueryParams,
    searching: state.searchPage.searching,
    searchPageKeyWords: state.searchPage.searchPageKeyWords,
    searchPagePriceData: state.searchPage.searchPagePriceData,
    searchPageSitesLeft: state.searchPage.searchPageSitesLeft
  }),
  {
    updateSearchPageQueryParams,
    updateSearching,
    updateSearchPageSearchKeyWords,
    updateSearchPagePriceData,

    startSearching,
    stopSearching,

    updateSearchPageSitesLeft,
    decrementSearchPageSitesLeft
  }
)(SearchPage);


// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPage.js